<template>
  <div>
    <Menu />

    <header class="hero hero-com">
      <div class="container">
        <div class="hero-topbar d-flex align-items-center justify-content-between">
          <div class="brand-lockup">
            <a href="/home" class="d-flex align-items-center text-decoration-none">
              <img src="https://www.stratitude.co.za/chas-international/dubai/images/chas-logo.svg" alt="Chas Everitt" class="brand-logo" loading="lazy" />
            </a>

            <span class="brand-divider d-none d-md-inline-block" aria-hidden="true"></span>

            <div class="d-none d-md-block">
              <a href="https://www.leadingre.com/" class="d-flex align-items-center text-decoration-none" target="_blank" rel="noopener noreferrer">
                <img src="https://www.stratitude.co.za/chas-international/dubai/images/leading-logo1.png" alt="Leading Real Estate" class="partner-logo" loading="lazy" />
              </a>
            </div>
          </div>

          <nav class="d-none d-lg-flex hero-nav align-items-center">
            <a class="nav-link" href="/properties">Buy</a>
            <a class="nav-link" href="/sell">Sell</a>
            <a class="nav-link" href="/developments">Developments</a>
            <a class="nav-link" href="/commercial">Commercial</a>
          </nav>

          <button class="btn hamburger d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileNav">
            <i class="bi bi-list" style="font-size:1.25rem;"></i>
          </button>
        </div>

        <div class="pt-5 pb-4">
          <h1 class="hero-title mb-3">
            Commercial Properties<br />in <strong>Dubai</strong>
          </h1>

          <!-- <div class="d-flex hero-tabs">
            <a href="#" class="active">Dubai</a>
            <a href="https://www.chaseveritt.co.zw/">Zimbabwe</a>
            <a href="#">Mauritius</a>
            <a href="https://www.chaseveritt.co.za/">South Africa</a>
          </div> -->

        </div>
      </div>
    </header>

    <div v-if="loading" class="py-5 text-center">
      Loading commercial listings...
    </div>

    <section class="search-strip" v-if="!loading">
      <div class="container">
        <form class="row g-2 align-items-center search-strip-desktop" @submit.prevent>
          <div class="col-12 col-md-6 col-xl-2">
            <select class="form-select" v-model="selectedListingType">
              <option value="">BUY / RENT</option>
              <option v-for="type in listingTypes" :key="type" :value="type">
                {{ type }}
              </option>
            </select>
          </div>

          <div class="col-12 col-md-6 col-xl-2">
            <select class="form-select" v-model="selectedPropertyType">
              <option value="">PROPERTY TYPE</option>
              <option v-for="type in propertyTypes" :key="type" :value="type">
                {{ type }}
              </option>
            </select>
          </div>

          <div class="col-12 col-md-6 col-xl-3 position-relative">
            <input type="text" class="form-control w-100" placeholder="ENTER A LOCATION" v-model="searchText" />

            <ul v-if="locationSuggestions.length > 0 && searchText != ''" class="list-group search-suggest">
              <li v-for="suggestion in locationSuggestions" :key="suggestion" class="list-group-item">
                <div @click="selectLocationSuggestion(suggestion)" style="cursor:pointer;">
                  {{ suggestion }}
                </div>
              </li>
            </ul>
          </div>

          <div class="col-6 col-md-3 col-xl-2">
            <select class="form-select" v-model.number="minPrice">
              <option :value="0">MIN PRICE</option>
              <option v-for="price in priceOptions" :key="'min-' + price" :value="price">
                {{ formatCurrency(price) }}
              </option>
            </select>
          </div>

          <div class="col-6 col-md-3 col-xl-2">
            <select class="form-select" v-model.number="maxPrice">
              <option :value="0">MAX PRICE</option>
              <option v-for="price in priceOptions" :key="'max-' + price" :value="price">
                {{ formatCurrency(price) }}
              </option>
            </select>
          </div>

          <div class="col-12 col-xl-1">
            <button class="btn btn-primary w-100 search-submit-btn" type="button">
              Search
            </button>
          </div>
        </form>
      </div>
    </section>

    <section v-if="!loading" class="py-5 bg-white">
      <div class="container text-center">
        <div class="row">
          <div class="col-12 mb-4">
            <div class="sort-strip d-inline-flex gap-2 align-items-center justify-content-center flex-wrap">
              <button type="button" class="btn btn-primary filter-btn sort-btn" :class="{ active: highToLow }" @click="setHighToLow">
                Price high to low
              </button>

              <button type="button" class="btn btn-primary filter-btn sort-btn" :class="{ active: !highToLow }" @click="setLowToHigh">
                Price low to high
              </button>

              <button type="button" class="btn btn-outline-secondary filter-btn sort-btn" @click="clearFilters">
                Clear filters
              </button>
            </div>
          </div>
        </div>

        <div class="row mb-3" v-if="activeCommercialListings.length > 0">
          <div class="col-12 text-start">
            <p class="mb-0">
              Showing {{ paginatedCommercialListings.length }} of {{ filteredCommercialListings.length }} commercial properties
            </p>
          </div>
        </div>

        <div class="row g-4" v-if="paginatedCommercialListings.length > 0">
          <div class="col-12 col-md-6 col-lg-4" v-for="listing in paginatedCommercialListings" :key="listing.id">
            <div class="listing-card h-100">
              <a class="listing-card__media" :href="propertyUrl(listing)">
                <img :src="featuredImage(listing)" class="listing-card__img" :alt="cleanText(listing.marketing_heading)" loading="lazy" />
              </a>

              <div class="listing-card__body text-start">
                <div class="listing-card__tags">
                  <span class="tag" v-if="listing.listing_type">{{ listing.listing_type }}</span>
                  <span class="tag" v-if="listing.property_type">{{ listing.property_type }}</span>
                </div>

                <p class="listing-card__price">
                  <strong>{{ displayPrice(listing) }}</strong>
                  <span v-if="listing.price_term"> / {{ listing.price_term }}</span>
                </p>

                <p class="listing-card__title text-uppercase">
                  <strong>{{ cleanText(listing.marketing_heading) }}</strong>
                </p>

                <p class="listing-card__meta">
                  {{ listing.loc_suburb }}, {{ listing.loc_region }}
                </p>

                <div class="listing-card__features">
                  <span v-if="showNumber(listing.building_size)">
                    {{ formatSize(listing.building_size, listing.building_measurement_type) }}
                  </span>
                  <span v-if="showNumber(listing.land_size)">
                    Land {{ formatSize(listing.land_size, listing.land_measurement_type) }}
                  </span>
                </div>

                <div class="listing-card__cta mt-3">
                  <a class="btn btn-cta filter-btn" :href="propertyUrl(listing)">
                    View <i class="bi bi-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="commercial-empty-state" v-else-if="activeCommercialListings.length == 0">
          <div class="empty-card mx-auto">
            <div class="empty-icon">
              <i class="bi bi-building"></i>
            </div>

            <h2>No commercial properties currently listed</h2>

            <p>
              There are currently no Dubai commercial listings available. Please check back soon,
              or contact the Chas Everitt International team for commercial opportunities.
            </p>

          </div>
        </div>

        <div class="commercial-empty-state" v-else>
          <div class="empty-card mx-auto">
            <div class="empty-icon">
              <i class="bi bi-search"></i>
            </div>

            <h2>No matching commercial properties</h2>

            <p>
              We have commercial listings, but none match your current filters.
            </p>

          </div>
        </div>

        <div class="row mt-4" v-if="totalPages > 1">
          <div class="col-12">
            <div class="d-flex justify-content-center align-items-center gap-2 flex-wrap">
              <button class="btn btn-primary filter-btn sort-btn" @click="prevPage" :disabled="currentPage == 1">
                Previous
              </button>

              <span class="px-2">Page {{ currentPage }} of {{ totalPages }}</span>

              <button class="btn btn-primary filter-btn sort-btn" @click="nextPage" :disabled="currentPage == totalPages">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="offcanvas offcanvas-end offcanvas-custom" tabindex="-1" id="mobileNav" aria-labelledby="mobileNavLabel">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title text-white" id="mobileNavLabel">Menu</h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>

      <div class="offcanvas-body">
        <div class="list-group list-group-flush">
          <a class="list-group-item list-group-item-action" href="/properties">Buy</a>
          <a class="list-group-item list-group-item-action" href="/sell">Sell</a>
          <a class="list-group-item list-group-item-action" href="/developments">Developments</a>
          <a class="list-group-item list-group-item-action" href="/commercial">Commercial</a>
        </div>
        <hr />
      </div>
    </div>

    <div class="mt-4"></div>

    <Footer />
  </div>
</template>

<script>
import axios from 'axios'
import Menu from '@/components/Menu.vue'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Menu,
    Footer
  },

  data() {
    return {
      commercialListings: [],
      loading: true,
      selectedListingType: '',
      selectedPropertyType: '',
      searchText: '',
      minPrice: 0,
      maxPrice: 0,
      currentPage: 1,
      itemsPerPage: 9,
      highToLow: true
    }
  },

  mounted() {
    this.fetchCommercialListings()
  },

  watch: {
    selectedListingType() {
      this.currentPage = 1
    },

    selectedPropertyType() {
      this.currentPage = 1
    },

    searchText() {
      this.currentPage = 1
    },

    minPrice() {
      this.currentPage = 1
    },

    maxPrice() {
      this.currentPage = 1
    },

    highToLow() {
      this.currentPage = 1
    }
  },

  computed: {
    normalisedCommercialListings() {
      return this.normaliseListings(this.commercialListings)
    },

    activeCommercialListings() {
      return this.normalisedCommercialListings.filter((listing) => {
        const status = this.safeString(listing.status).toLowerCase()

        if (status == 'archived') {
          return false
        }

        if (status == 'sold') {
          return false
        }

        if (status == 'inactive') {
          return false
        }

        if (status.indexOf('under offer') !== -1) {
          return false
        }

        if (!Array.isArray(listing.listing_images)) {
          return false
        }

        if (listing.listing_images.length == 0) {
          return false
        }

        return true
      })
    },

    listingTypes() {
      return this.uniqueSortedValues('listing_type')
    },

    propertyTypes() {
      return this.uniqueSortedValues('property_type')
    },

    priceOptions() {
      const prices = this.activeCommercialListings
        .map((listing) => {
          return this.priceNumber(listing.price)
        })
        .filter((price) => {
          return price > 0 && price != 999999999
        })

      const roundedPrices = prices.map((price) => {
        if (price <= 250000) {
          return Math.ceil(price / 50000) * 50000
        }

        if (price <= 1000000) {
          return Math.ceil(price / 100000) * 100000
        }

        return Math.ceil(price / 1000000) * 1000000
      })

      return Array.from(new Set(roundedPrices)).sort((a, b) => {
        return a - b
      })
    },

    locationSuggestions() {
      const text = this.searchText.toLowerCase()

      const locations = this.activeCommercialListings.map((listing) => {
        const suburb = listing.loc_suburb || ''
        const region = listing.loc_region || ''

        if (suburb != '' && region != '') {
          return suburb + ', ' + region
        }

        if (suburb != '') {
          return suburb
        }

        return region
      })

      return Array.from(new Set(locations))
        .filter((location) => {
          if (location == '') {
            return false
          }

          return location.toLowerCase().includes(text)
        })
        .sort()
        .slice(0, 8)
    },

    filteredCommercialListings() {
      const filtered = this.activeCommercialListings.filter((listing) => {
        if (this.selectedListingType != '') {
          if (listing.listing_type != this.selectedListingType) {
            return false
          }
        }

        if (this.selectedPropertyType != '') {
          if (listing.property_type != this.selectedPropertyType) {
            return false
          }
        }

        if (this.searchText != '') {
          const haystack = [
            listing.loc_suburb,
            listing.loc_region,
            listing.marketing_heading,
            listing.property_type,
            listing.listing_type
          ].join(' ').toLowerCase()

          if (!haystack.includes(this.searchText.toLowerCase())) {
            return false
          }
        }

        if (this.minPrice > 0) {
          if (!this.isPOA(listing)) {
            if (this.priceNumber(listing.price) < this.minPrice) {
              return false
            }
          }
        }

        if (this.maxPrice > 0) {
          if (!this.isPOA(listing)) {
            if (this.priceNumber(listing.price) > this.maxPrice) {
              return false
            }
          }
        }

        return true
      })

      filtered.sort((a, b) => {
        const priceA = this.priceNumber(a.price)
        const priceB = this.priceNumber(b.price)

        if (this.highToLow) {
          return priceB - priceA
        }

        return priceA - priceB
      })

      return filtered
    },

    totalPages() {
      const pages = Math.ceil(this.filteredCommercialListings.length / this.itemsPerPage)

      if (pages < 1) {
        return 1
      }

      return pages
    },

    paginatedCommercialListings() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage
      const endIndex = startIndex + this.itemsPerPage

      return this.filteredCommercialListings.slice(startIndex, endIndex)
    }
  },

  methods: {
    async fetchCommercialListings() {
      this.loading = true

      try {
        const response = await axios.get(
          'https://chas-dubai.stratitude-develop.co.za/api/fetch-listings-commercial.php',
          {
            headers: {
              Accept: 'application/json'
            }
          }
        )

        const payload = response && response.data ? response.data : []

        if (Array.isArray(payload)) {
          this.commercialListings = payload
        } else if (payload && Array.isArray(payload.data)) {
          this.commercialListings = payload.data
        } else if (payload && Array.isArray(payload.listing)) {
          this.commercialListings = payload.listing
        } else if (payload && payload.data && Array.isArray(payload.data.listing)) {
          this.commercialListings = payload.data.listing
        } else {
          this.commercialListings = []
        }
      } catch (error) {
        console.log(error)
        this.commercialListings = []
      }

      this.loading = false
    },

    normaliseListings(listings) {
      if (!Array.isArray(listings)) {
        return []
      }

      return listings
        .filter((listing) => {
          if (!listing) {
            return false
          }

          if (listing[0]) {
            return true
          }

          if (listing.id) {
            return true
          }

          return false
        })
        .map((listing) => {
          if (listing[0]) {
            return Object.assign({}, listing[0])
          }

          return Object.assign({}, listing)
        })
    },

    uniqueSortedValues(fieldName) {
      const values = this.activeCommercialListings
        .map((listing) => {
          return listing[fieldName]
        })
        .filter((value) => {
          if (!value) {
            return false
          }

          return true
        })

      return Array.from(new Set(values)).sort()
    },

    selectLocationSuggestion(suggestion) {
      this.searchText = suggestion
    },

    clearFilters() {
      this.selectedListingType = ''
      this.selectedPropertyType = ''
      this.searchText = ''
      this.minPrice = 0
      this.maxPrice = 0
      this.currentPage = 1
    },

    setHighToLow() {
      this.highToLow = true
      this.currentPage = 1
    },

    setLowToHigh() {
      this.highToLow = false
      this.currentPage = 1
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1
      }
    },

    propertyUrl(listing) {
      if (!listing || !listing.id) {
        return '/commercial'
      }

      return '/commercialv/' + listing.id
    },

    featuredImage(listing) {
      if (!listing || !Array.isArray(listing.listing_images)) {
        return ''
      }

      if (listing.listing_images.length == 0) {
        return ''
      }

      return listing.listing_images[0]
    },

    displayPrice(listing) {
      if (!listing) {
        return ''
      }

      if (this.isPOA(listing)) {
        return 'POA'
      }

      return this.formatCurrency(listing.price)
    },

    formatCurrency(value) {
      const amount = parseInt(value, 10)

      if (isNaN(amount)) {
        return 'AED 0'
      }

      return new Intl.NumberFormat('en-AE', {
        style: 'currency',
        currency: 'AED',
        maximumFractionDigits: 0
      }).format(amount)
    },

    formatSize(value, unit) {
      const number = this.numberValue(value)

      if (number == 0) {
        return '—'
      }

      const cleanNumber = new Intl.NumberFormat('en-AE', {
        maximumFractionDigits: 0
      }).format(number)

      if (unit == 'Square Feet') {
        return cleanNumber + ' sqft'
      }

      if (unit == 'Square Metres' || unit == 'Square Meters') {
        return cleanNumber + ' sqm'
      }

      if (unit) {
        return cleanNumber + ' ' + unit
      }

      return cleanNumber
    },

    showNumber(value) {
      return this.numberValue(value) > 0
    },

    priceNumber(value) {
      const price = parseInt(value, 10)

      if (isNaN(price)) {
        return 0
      }

      return price
    },

    numberValue(value) {
      const number = parseFloat(value)

      if (isNaN(number)) {
        return 0
      }

      return number
    },

    safeString(value) {
      if (!value) {
        return ''
      }

      return value.toString()
    },

    isPOA(listing) {
      if (!listing) {
        return false
      }

      if (listing.poa === true) {
        return true
      }

      if (listing.poa == 'true') {
        return true
      }

      if (parseInt(listing.price, 10) == 999999999) {
        return true
      }

      return false
    },

    cleanText(value) {
      if (!value) {
        return ''
      }

      return value
        .toString()
        .replace(/ΓÇö/g, '—')
        .replace(/ΓÇô/g, '–')
        .replace(/ΓÇÖ/g, '’')
        .replace(/ΓÇ£/g, '“')
        .replace(/ΓÇ¥/g, '”')
        .replace(/ΓÇó/g, '•')
        .replace(/Γ£ö∩╕Å/g, '✓')
        .replace(/≡ƒôì/g, '📍')
        .replace(/ΓÇª/g, '…')
        .replace(/┬á/g, ' ')
        .replace(/&amp;/g, '&')
    }
  }
}
</script>

<style scoped>
.search-toggle-group .btn {
  border-radius: 0 !important;
  height: 46px;
  padding: 0 .75rem;
  font-size: .78rem;
  letter-spacing: .05em;
  text-transform: uppercase;
}

.search-submit-btn {
  border-radius: 0 !important;
  height: 46px;
  font-size: .78rem;
  letter-spacing: .05em;
  text-transform: uppercase;
  white-space: nowrap;
}

.search-suggest {
  position: absolute;
  top: calc(46px + 6px);
  left: 12px;
  right: 12px;
  z-index: 50;
  border-radius: 0 !important;
  border: 1px solid #e5ecf5;
  max-height: 240px;
  overflow: auto;
  background: #fff;
}

.search-suggest .list-group-item {
  border-color: #e5ecf5;
  text-transform: uppercase;
  letter-spacing: .04em;
  font-size: .8rem;
  color: #2c4a6c;
}

.search-suggest .list-group-item:hover {
  background: #f4f6f8;
}

.tag {
  background-color: #255699;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 5px 20px;
  border-radius: 0;
  display: inline-block;
  margin-right: 5px;
  margin-bottom: 5px;
}

.listing-card__media {
  display: block;
  overflow: hidden;
}

.listing-card__img {
  width: 100%;
  height: 300px;
  object-fit: cover;
  display: block;
}

.listing-card__features {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 14px;
}

.listing-card__price {
  margin-top: 15px;
}

.empty-card {
  max-width: 720px;
  background: #f7f7f7;
  padding: 48px 32px;
  border-radius: 18px;
}

.empty-icon {
  width: 74px;
  height: 74px;
  border-radius: 50%;
  background: #255699;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  margin-bottom: 20px;
}

.empty-card h2 {
  font-size: 30px;
  font-weight: 800;
  color: #333;
}

.empty-card p {
  color: #555;
  max-width: 560px;
  margin: 0 auto 24px;
}

@media (min-width: 1200px) {
  .search-strip-desktop {
    flex-wrap: nowrap;
  }

  .search-strip-desktop>[class*="col-"] {
    flex: 0 0 auto;
  }

  .search-strip-desktop .form-select,
  .search-strip-desktop .form-control,
  .search-strip-desktop .btn {
    height: 46px;
  }
}
</style>